import { render, staticRenderFns } from "./SendPasswordInstructions.vue?vue&type=template&id=0bbeb41c&scoped=true&"
import script from "./SendPasswordInstructions.vue?vue&type=script&lang=ts&"
export * from "./SendPasswordInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./SendPasswordInstructions.vue?vue&type=style&index=0&id=0bbeb41c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbeb41c",
  null
  
)

export default component.exports